import { render, staticRenderFns } from "./ImageUpload.vue?vue&type=template&id=10715014&scoped=true&"
import script from "./ImageUpload.vue?vue&type=script&lang=js&"
export * from "./ImageUpload.vue?vue&type=script&lang=js&"
import style0 from "./ImageUpload.vue?vue&type=style&index=0&id=10715014&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10715014",
  null
  
)

export default component.exports